import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '',
    name: 'GET_MATERIAL_RECORDS',
    method: 'GET',
  });
  useEffect(() => {
    if (param) {
      let url = `/api/material/records`;
      Object.keys(param).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${param[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return [isRequestSuccessed, data || [], exec, isLoading];
});
